module.exports = __webpack_public_path__ + "img/box-open.5c54d391.svg";